/** Mirrors apps/server/src/modules/config-institucional/fuso.util.ts */

import { IJornadaConfig } from '../interfaces/configuracao';

/** Same starting point the server seeds: our proposal, still to be confirmed. */
export const FUSO_FABRICA_PADRAO = 'America/Sao_Paulo';

/** IANA zone plus the i18n key of its label, in display order. */
export interface IFusoOpcao {
  fuso: string;
  /** `null` for a zone saved outside the offered list: the label is the zone itself. */
  labelKey: string | null;
}

/** The zones the editor offers, the ones a Brazilian factory can sit in. */
export const FUSOS_OFERECIDOS: Array<IFusoOpcao> = [
  { fuso: 'America/Sao_Paulo', labelKey: 'saoPaulo' },
  { fuso: 'America/Belem', labelKey: 'belem' },
  { fuso: 'America/Fortaleza', labelKey: 'fortaleza' },
  { fuso: 'America/Manaus', labelKey: 'manaus' },
  { fuso: 'America/Cuiaba', labelKey: 'cuiaba' },
  { fuso: 'America/Rio_Branco', labelKey: 'rioBranco' },
  { fuso: 'America/Noronha', labelKey: 'noronha' },
];

/** The zone in force. A document saved before the field existed shows the seed, the same one the server falls back to. */
export function fusoFabrica(jornada: Partial<IJornadaConfig> | undefined): string {
  const gravado = jornada?.fusoHorario;
  return typeof gravado === 'string' && gravado !== '' ? gravado : FUSO_FABRICA_PADRAO;
}

/**
 * Options of the zone select. A zone saved outside the offered list stays in it,
 * so opening the screen and saving never silently replaces what is in force.
 */
export function fusosDoSelect(atual: string): Array<IFusoOpcao> {
  if (FUSOS_OFERECIDOS.some((opcao) => opcao.fuso === atual)) {
    return FUSOS_OFERECIDOS;
  }
  return [...FUSOS_OFERECIDOS, { fuso: atual, labelKey: null }];
}

/** i18n key of the short city name, for the one-line summary. `null` keeps the raw zone. */
export function fusoCidadeKey(atual: string): string | null {
  return FUSOS_OFERECIDOS.find((opcao) => opcao.fuso === atual)?.labelKey ?? null;
}

/**
 * The day 'YYYY-MM-DD' an instant has in THAT zone. Mirrors `diaNoFuso` on the server:
 * the day is built from the parts because the order of a localised format is not a
 * contract, and the offset comes from the zone itself (daylight saving included).
 */
export function diaNoFuso(instante: Date, fuso: string): string {
  const partes = new Intl.DateTimeFormat('en-US', {
    timeZone: fuso,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(instante);
  const valor = (tipo: string): string => partes.find((parte) => parte.type === tipo)?.value ?? '';
  return `${valor('year')}-${valor('month')}-${valor('day')}`;
}

/**
 * Today in the FACTORY's zone. The browser clock is the reader's, not the factory's: a
 * screen opened from another zone (or a laptop with the wrong clock) was asking the API
 * for a different day than the one the floor is working.
 */
export function hojeNaFabrica(jornada: Partial<IJornadaConfig> | undefined): string {
  return diaNoFuso(new Date(), fusoFabrica(jornada));
}
